export class HtmlFile {
    htmlName: string;
    htmlContent: string;

    constructor(htmlName?: string, htmlContent?: string) {
        this.htmlName = htmlName;
        this.htmlContent = htmlContent;
    }
}
